import _ from 'lodash'
import { LAYOUT_MODE } from '../constants/toUnits'
import { TAB_TYPES } from '../lib/tab-utils'
import { List, Map, fromJS } from 'immutable'

const iCollectElementParentHash = (elements, elemID, parentList) => {
  const elem = elements.get(elemID, Map())
  if (!elem.size === 0) {
    return []
  }
  const parent = elem.get('parent')
  if (parentList.includes(parent)) {
    return []
  }
  return [parent, ...iCollectElementParentHash(elements, parent, [...parentList, parent])]
}

const collectElementParentHash = (elements, elemID, parentList) => {
  const elem = elements[elemID]
  if (!elem) {
    return []
  }
  const parent = elem.parent
  if (parentList.includes(parent)) {
    return []
  }
  return [parent, ...collectElementParentHash(elements, parent, [...parentList, parent])]
}

export const iCollectElementsParentHash = (elements = Map()) => {
  const hash = {}
  elements.map((elem, elemID) => {
    hash[elemID] = [elemID, ...iCollectElementParentHash(elements, elemID, [])]
  })
  return hash
}

export const collectElementsParentHash = (elements = {}) => {
  const hash = {}
  _.each(elements, (elem, elemID) => {
    hash[elemID] = [elemID, ...collectElementParentHash(elements, elemID, [])]
  })
  return hash
}

export const iFixElementChildren = (elem, list = []) => {
  let outElem = Map.isMap(elem) ? elem : Map()

  if (outElem && outElem.get('children', List()).size > 0) {
    const childrenJS = outElem.get('children', List()).toJS()
    const children = _.filter(childrenJS, (childId) => {
      if (_.isArray(childId)) {
        return _.filter(childId, (id) => !_.includes(list, id))
      } else {
        return !_.includes(list, childId)
      }
    })
    outElem = outElem.set('children', fromJS(children))
  }
  if (TAB_TYPES.includes(outElem.get('type'))) {
    _.each(LAYOUT_MODE, (mode) => {
      const tabs = outElem.getIn(['props', mode, 'tabs'], List())
      if (tabs) {
        tabs.map((tab, tabIndex) => {
          const childrenJS = tab.get('children', List()).toJS()
          const children = _.filter(childrenJS, (childId) => !_.includes(list, childId))
          outElem = outElem.setIn(['props', mode, 'tabs', tabIndex, 'children'], fromJS(children))
        })
      }
    })
  }

  if (outElem.get('type') === 'Form') {
    _.each(LAYOUT_MODE, (mode) => {
      const childRows = outElem.getIn(['props', mode, 'children'], Map())
      childRows.map((row, rowId) => {
        row.get('children', Map()).map((col, colId) => {
          const childrenJS = col.get('children', List()).toJS()
          const children = _.filter(childrenJS || [], (childId) => !_.includes(list, childId))
          outElem.setIn(['props', mode, 'children', rowId, 'children', colId, 'children'], fromJS(children))
        })
      })
    })
  }

  return outElem
}

export const fixElementChildren = (elem, list = []) => {
  const outElem = JSON.parse(JSON.stringify(elem || {}))

  if (outElem && outElem.children) {
    const children = _.filter(outElem.children, (childId) => {
      if (_.isArray(childId)) {
        return _.filter(childId, (id) => !_.includes(list, id))
      } else {
        return !_.includes(list, childId)
      }
    })
    _.set(outElem, ['children'], children)
  }
  if (TAB_TYPES.includes(outElem.type)) {
    _.each(LAYOUT_MODE, (mode) => {
      const tabs = _.get(outElem, ['props', mode, 'tabs'], [])
      if (tabs) {
        _.each(tabs, (tab, tabIndex) => {
          const children = _.filter(tab.children, (childId) => !_.includes(list, childId))
          _.set(outElem, ['props', mode, 'tabs', tabIndex, 'children'], children)
        })
      }
    })
  }

  if (outElem.type === 'Form') {
    _.each(LAYOUT_MODE, (mode) => {
      const childRows = _.get(outElem, ['props', mode, 'children'], {})
      _.each(childRows, (row, rowId) => {
        _.each(row.children, (col, colId) => {
          const children = _.filter(col.children || [], (childId) => !_.includes(list, childId))
          _.set(outElem, ['props', mode, 'children', rowId, 'children', colId, 'children'], children)
        })
      })
    })
  }

  return outElem
}
